import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { onConsentChange } from '@/lib/consent'
import { clearVisitorIds, sendPageView } from '@/lib/visitor'

/** Beacon di visita verso CRMiaba a ogni cambio di rotta (vedi lib/visitor.ts). */
export function RouteTracker() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    sendPageView()
  }, [pathname, search])

  // Consenso dato ora → conta la pagina corrente; revocato → via i cookie.
  useEffect(() => onConsentChange((state) => {
    if (state.marketing) sendPageView()
    else clearVisitorIds()
  }), [])

  return null
}
